module.exports = __webpack_public_path__ + "static/media/lines.8935893b.png";